import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import server from '../../../api/server';
import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';
import { CheckboxField } from '../ui/FormField';

// Redesign of newadmin/elements/ResetDataModal.js — same
// /admin/application/reset payload (including the always-false factfind key)
// and the same full page reload afterwards.
const ResetDataModal = ({ open, onClose }) => {
    const user = useSelector((s) => s.user);
    const applicationId = useSelector((s) => s.admin.active_application.application.id);

    const [voi, setVoi] = useState(false);
    const [files, setFiles] = useState(false);
    const [bankstatements, setBankstatements] = useState(false);
    const [consent, setConsent] = useState(false);

    const formSubmit = async (e) => {
        e.preventDefault();
        await server.post('/admin/application/reset', {
            id: user.token,
            data: { factfind: false, voi, files, bankstatements, consent },
            application_id: applicationId,
        });
        window.location.reload();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Reset Data"
            subtitle="Select the fields you wish to reset the data for."
            size="sm"
        >
            <form onSubmit={formSubmit} className="flex flex-col flex-1 min-h-0 overflow-hidden">
                <ModalBody className="flex-1 space-y-2">
                    <CheckboxField
                        label="Verification of Identity"
                        checked={voi}
                        onChange={() => setVoi(!voi)}
                        className="rounded-xl border border-[#E5E7EB] px-3 py-3 hover:bg-[#FAFAFC] transition-colors"
                    />
                    <CheckboxField
                        label="Document Collection"
                        checked={files}
                        onChange={() => setFiles(!files)}
                        className="rounded-xl border border-[#E5E7EB] px-3 py-3 hover:bg-[#FAFAFC] transition-colors"
                    />
                    <CheckboxField
                        label="Bank Statements"
                        checked={bankstatements}
                        onChange={() => setBankstatements(!bankstatements)}
                        className="rounded-xl border border-[#E5E7EB] px-3 py-3 hover:bg-[#FAFAFC] transition-colors"
                    />
                    <CheckboxField
                        label="Privacy Consent"
                        checked={consent}
                        onChange={() => setConsent(!consent)}
                        className="rounded-xl border border-[#E5E7EB] px-3 py-3 hover:bg-[#FAFAFC] transition-colors"
                    />
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={onClose}>
                        Close
                    </Button>
                    <Button variant="danger" type="submit">
                        Reset Data
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default ResetDataModal;
